exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1V9eK {\n  padding: 40px 20px;\n}\n._1V9eK .V-oTC {\n  width: 126px;\n  max-width: 100%;\n}\n._1V9eK ._1V6_f {\n  padding: 10px 20px;\n}\n.uk-h5, .uk-h6 {\n  font-family: \"Montserrat\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n", ""]);

// Exports
exports.locals = {
	"logoContainer": "_1V9eK",
	"logo": "V-oTC",
	"text": "_1V6_f"
};